import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

type Props = {
  /** The page's map area, width / height. */
  aspectRatio: number;
};

/**
 * Shows over the 3D view what the report shows of it: the middle of the canvas, as large as the
 * page's map area allows, as the backend and the screenshot crop it. The rest is dimmed.
 */
const CameraViewCrop = ({ aspectRatio }: Props) => {
  const canvasContainer = document.getElementById('webglrenderercontainer');
  if (!canvasContainer) {
    return null;
  }

  return createPortal(
    <Overlay data-aspect-ratio={aspectRatio} data-testid="camera-view-crop">
      <Crop $aspectRatio={aspectRatio} />
    </Overlay>,
    canvasContainer,
  );
};

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  container-type: size;
  pointer-events: none;
`;

const Crop = styled.div<{ $aspectRatio: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(100cqw, calc(100cqh * ${(props) => props.$aspectRatio}));
  height: min(100cqh, calc(100cqw / ${(props) => props.$aspectRatio}));
  transform: translate(-50%, -50%);
  outline: 2px solid ${(props) => props.theme.color.brand.dark};
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.35);
`;

export { CameraViewCrop };
